/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import Ref from '../Ref'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import TransactionStatusBadge from '../transaction/TransactionStatusBadge'
import { getTransactionLink } from '../../lib/links/transactionLinks'
import RequirePerm from '../../../auth/components/RequirePerm'
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { useIntl } from 'react-intl'
import { getInvoiceLink } from '../../lib/links/invoiceLinks'
import { Button, Group, Table, Tooltip } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import Amount from '../transaction/Amount'

export type ManagementReportItemProps = {
  item: ManagementReportItem
  onDelete (item: ManagementReportItem): void
}

function ManagementReportItem (props: ManagementReportItemProps) {
  const { item, onDelete } = props
  const intl = useIntl()

  return <Table.Tr
    key={item.id}
    style={{ opacity: item.paid ? 1 : 0.5 }}
  >
    <Table.Td>
      {intl.formatDate(item.date)}
    </Table.Td>
    <Table.Td>
      {item.invoiceReference
        ? <AnchorLink to={getInvoiceLink(item.invoiceId)}>
          <Ref value={item.invoiceReference} />
        </AnchorLink>
        : null}
    </Table.Td>
    <Table.Td>
      <Group gap="xs">
        <RequirePerm
          permissions={[
            'write:invoice',
            'write:transaction'
          ]}
          render={() => <Button
            onClick={() => {
              onDelete(item)
            }}
            size="compact-xs"
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>}
        />

        <AnchorLink to={getTransactionLink(item.id, item.expense)}>
          {item.label}
        </AnchorLink>

        {!item.generated
          ? <Tooltip
            label={intl.formatMessage({
              id: 'manual_transaction_info',
              defaultMessage: 'Transaction ajoutée manuellement'
            })}
          >
            <FontAwesomeIcon
              fixedWidth
              icon={faInfoCircle}
            />
          </Tooltip>
          : null}

        {!item.paid
          ? <TransactionStatusBadge size="xs" transaction={item} />
          : null}
      </Group>
    </Table.Td>
    <Table.Td ta="end">
      {item.revenues > 0
        ? <Amount value={item.revenues} inherit />
        : null}
    </Table.Td>
    <Table.Td ta="end">
      {item.expenses <= 0
        ? <Amount value={item.expenses} inherit />
        : null}
    </Table.Td>
    <Table.Td ta="end">
      {item.vat != null && item.vat !== 0
        ? <Amount value={item.vat} inherit />
        : null}
    </Table.Td>
    <Table.Td ta="end">
      {item.cps != null && item.cps !== 0
        ? <Amount value={item.cps} inherit />
        : null}
    </Table.Td>
  </Table.Tr>
}

export default ManagementReportItem
